<template>
    <div>
        <div v-for="(line, linePosition) in localEmails" v-bind:key="linePosition">
            <v-row>
                <v-col cols="12" md="6">
                <v-text-field
                    v-model="line.email"
                    prepend-icon="mdi-email"
                    data-testid="new-contact-email"
                    :label="$t('contacts.columns.email')"
                    :rules="emailRules"
                    placeholder=''
                    @input="updateLine(linePosition, line)"
                ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                <v-text-field
                    v-model="line.label"
                    :rules="labelRules"
                    label="Label"
                    @input="updateLine(linePosition, line)"
                ></v-text-field>
                </v-col>
                <v-col cols="12" md="1" class="mt-4 mr-4">
                <v-btn
                    text
                    color="red"
                    icon
                    :disabled="disableDelete(line, linePosition)"
                    @click="deleteLine(linePosition)"
                >
                    <v-icon>mdi-delete</v-icon>
                </v-btn>
                </v-col>
                <v-col cols="12" md="1" class="mt-4">
                <v-btn
                    text
                    color="primary"
                    icon
                    @click="addLine()"
                >
                    <v-icon>mdi-plus</v-icon>
                </v-btn>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'contacts-form-fields-mainTab-emails',
  data () {
    return {
      supportedCountries: ['CA', 'US', 'AU'],
      localEmails: [],
      labelRules: [
        v => (v === null || v?.length === 0 || v?.length >= 2) || this.$t('contacts.formValidation.minimumChar', { min: 2 })
      ],
      emailRules: [
        v => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || this.$t('contacts.formValidation.validEmail')
      ]
    }
  },
  created () {
    this.initLines()
  },
  computed: {
    ...mapGetters({
      contact: 'contacts/form/contact'
    }),
    emails: { get () { return this.contact?.emails }, set (emails) { this.setEmails(emails) } }
  },
  watch: {
    emails: {
      handler (newVal) {
        // deep clone to avoid inheriting vuex watchers
        this.localEmails = newVal.map(item => ({ ...item }))
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions({
      setEmails: 'contacts/form/setEmails'
    }),

    initLines () {
      if (this.emails.length === 0) {
        this.addLine()
      }
    },

    addLine () {
      this.emails = [...this.emails, { email: '', label: '' }]
    },

    updateLine (index, email) {
      this.emails = this.emails.toSpliced(index, 1, email)
    },

    deleteLine (linePosition) {
      this.emails = this.emails.filter((item, index) => index !== linePosition)
    },

    disableDelete (line, linePosition) {
      return this.emails.length === 1 && !(linePosition || line.email || line.label)
    }
  }
}
</script>

<style>

</style>
